import AutoplayDataParser from "../../../../vendor_core/src/server/parsers/AutoplayDataParser";
import { IAutoplaySettings } from "../../../../vendor_core/core/src/server/data/IAutoplayData";

export default class BURAutoplayDataParser extends AutoplayDataParser {
    check(data: any): boolean {
        return data?.data?.gameData?.meterConfig;
    }

    public parse(data: any): IAutoplaySettings[] {
        return super.parse(data);
    }
}
